<fl-service-provider-request
  (allow)="setValue(true)"
  (deny)="setValue(false)"
  [clientName]="renderedFormService.dynamicModels['INVESTOR.LEGAL_NAME']"
  [image]="renderedFormService.dynamicModels['INVESTMENT.PROVIDER_LOGO']"
  [providerName]="renderedFormService.dynamicModels['INVESTMENT.PROVIDER_LEGAL_NAME']"
></fl-service-provider-request>
